<div class="membershipTableDiv mx-3 mb-3">

<div class="row row justify-content-center">
  <div class="col-10 mt-3 mr-5">
    <h2 class="mx-2">{{mainHeader}}</h2>
  </div>
  <div class="d-flex justify-content-end align-items-center col-2">
    <button mat-icon-button [mat-dialog-close]="'close'"><mat-icon>close</mat-icon></button>
  </div>
</div>
  <section class="example-container mat-elevation-z8 m-2" tabindex="0">
    <table mat-table [dataSource]="rows" matSort>

      @for(column of displayedColumns; track column; let i = $index) {
        <ng-container [matColumnDef]="column">
          <th class="m-1 p-3" mat-header-cell *matHeaderCellDef> {{header[i]}} </th>
          @if(column == 'date') {
            <td class="m-1 p3" mat-cell *matCellDef="let element"> {{element[column] | date: 'MM/dd/yyyy HH:mm'}} </td>
          }
          @else {
            <td class="m-1 p3" mat-cell *matCellDef="let element"> {{element[column]}} </td>
          }
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  </section>
</div>
